import _ from 'lodash'
/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff. If no diff it will return null.
 * 
 * Source: https://gist.github.com/Yimiprod/7ee176597fef230d1451
 */

export default {
	diff: (object, base, checkCondition = false) => {
		if (!object || !base) {
			console.error('Can not diff object if one of them is undefined.')
			return object !== base
		}
		const changes = (object, base) => _.transform(object, function (result, value, key) {
			if (!_.isEqual(value, base[key])) {
				const res = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
				if (!_.isObject(res)) {
					result[key] = res;
				} else if (Object.keys(res).length > 0) {
					result[key] = res;
				}
			}
		});
		const changesObj = changes(object, base)
		if (Object.keys(changesObj).length > 0) return changesObj;
		if (checkCondition) return changesObj;
		return null;
	}
}